import type { ActionCardProps } from '@pcln/horizon'

const ICON_SYMBOL = {
  Help: 'help',
  Cars: 'directions_car',
  Discount: 'sell',
  Phone: 'phone',
  Verified: 'verified',
} as const

type Content = {
  heading: string
  href?: string
  iconName: keyof typeof ICON_SYMBOL
  subtext: string
}

type Banner = {
  content: Content[]
}

function getActionCardLinkProps(
  href?: string,
): Pick<ActionCardProps, 'role' | 'href' | 'anchorProps' | 'readOnly'> {
  return href
    ? {
        anchorProps: { rel: 'noopener noreferrer', target: '_blank' },
        href,
        role: 'link',
      }
    : { readOnly: true }
}

export { ICON_SYMBOL, getActionCardLinkProps, type Banner, type Content }
